import React from 'react';
import { Select } from 'antd';

const MonotaxSwitch: React.FC<any> = (props) => {
  return (
    <Select {...props}>
      <Select.Option value='false'>El R.I.M. <b>NO</b> declara monotributo</Select.Option>
      <Select.Option value='true'>El R.I.M. declara monotributo</Select.Option>
    </Select>
  );
};

export default MonotaxSwitch;